import { ApplicationStore } from '../states'

export const updateUserId: (state: ApplicationStore, payload: number) => ApplicationStore = (state, payload) => {
  return {
    ...state,
    userId: payload,
  }
}

export const removeUserId: (state: ApplicationStore) => ApplicationStore = (state) => {
  const newState: ApplicationStore = JSON.parse(JSON.stringify(state))

  delete newState.userId
  return {
    ...newState,
  }
}
